{
  "v": "5.7.8",
  "fr": 30,
  "ip": 0,
  "op": 91,
  "w": 106,
  "h": 100,
  "nm": "star_still",
  "ddd": 0,
  "assets": [],
  "layers": [
    {
      "ao": 0,
      "bm": 0,
      "ddd": 0,
      "ind": 1,
      "ip": 0,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.833 ],
                "y": [ 0.833 ]
              },
              "o": {
                "x": [ 0.167 ],
                "y": [ 0.167 ]
              },
              "t": 114,
              "s": [ 100 ]
            },
            {
              "t": 120,
              "s": [ 0 ]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 10
        },
        "p": {
          "a": 0,
          "k": [ 42.905, 72.019, 0 ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [ 42.905, 72.019, 0 ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 0,
          "k": [ 100, 100, 100 ],
          "ix": 6,
          "l": 2
        }
      },
      "nm": "Stjärna skugga",
      "op": 91,
      "parent": 2,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [ 0, 0 ],
                    [ 0.371, -0.478 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.569, 0.203 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.019, 0.604 ],
                    [ 0, 0 ],
                    [ -1.654, 4.876 ]
                  ],
                  "o": [
                    [ 0.602, -0.061 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.242, 0.552 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.453, 0.402 ],
                    [ 0, 0 ],
                    [ 8.163, -4.786 ],
                    [ 0, 0 ]
                  ],
                  "v": [
                    [ 8.405, -9.994 ],
                    [ 9.081, -8.774 ],
                    [ 3.815, -2.021 ],
                    [ 7.174, 5.824 ],
                    [ 6.308, 6.749 ],
                    [ -1.82, 3.943 ],
                    [ -8.262, 9.653 ],
                    [ -9.433, 9.077 ],
                    [ -9.372, 7.154 ],
                    [ 4.107, -9.415 ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [ 0.957090549843, 0.699869851505, 0.223505117379, 1 ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [ 43.014, 72.108 ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [ 0, 0 ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [ 100, 100 ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "sr": 1,
      "st": 0,
      "ty": 4
    },
    {
      "ddd": 0,
      "ind": 2,
      "ty": 4,
      "nm": "Stjärna fyll",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.833 ],
                "y": [ 0.833 ]
              },
              "o": {
                "x": [ 0.167 ],
                "y": [ 0.167 ]
              },
              "t": 114,
              "s": [ 100 ]
            },
            {
              "t": 120,
              "s": [ 0 ]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.062 ],
                "y": [ 0.984 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 1,
              "s": [ -37 ]
            },
            {
              "t": 23,
              "s": [ 0 ]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 0,
          "k": [ 53.208, 49.921, 0 ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [ 39.208, 68.881, 0 ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 4,
              "s": [ 87, 87, 100 ]
            },
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 12,
              "s": [ 112, 112, 100 ]
            },
            {
              "t": 31,
              "s": [ 100, 100, 100 ]
            }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [ -0.337, -0.493 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.372, -0.476 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.567, 0.197 ],
                    [ 0.898, 0.313 ],
                    [ 1.801, 0.629 ],
                    [ 0, 0 ],
                    [ -0.022, 0.599 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.581, 0.172 ],
                    [ 0, 0 ],
                    [ 0, 0 ]
                  ],
                  "o": [
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.601, -0.064 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.239, 0.547 ],
                    [ -1.797, -0.628 ],
                    [ -0.901, -0.314 ],
                    [ 0, 0 ],
                    [ -0.454, 0.401 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.519, -0.298 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.133, -0.585 ]
                  ],
                  "v": [
                    [ -1.133, -12.775 ],
                    [ 3.677, -5.746 ],
                    [ 12.26, -6.652 ],
                    [ 12.866, -5.561 ],
                    [ 7.549, 1.238 ],
                    [ 10.961, 9.042 ],
                    [ 10.094, 9.965 ],
                    [ 6.051, 8.553 ],
                    [ 1.997, 7.137 ],
                    [ -4.477, 12.867 ],
                    [ -5.618, 12.345 ],
                    [ -5.305, 3.798 ],
                    [ -12.719, -0.465 ],
                    [ -12.557, -1.709 ],
                    [ -4.267, -4.164 ],
                    [ -2.375, -12.528 ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [ 0.905205640606, 0.78973161286, 0.30304218367, 1 ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [ 39.229, 68.894 ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [ 0, 0 ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [ 100, 100 ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 91,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 3,
      "ty": 4,
      "nm": "Stjärna outlines",
      "parent": 2,
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.833 ],
                "y": [ 0.833 ]
              },
              "o": {
                "x": [ 0.167 ],
                "y": [ 0.167 ]
              },
              "t": 114,
              "s": [ 100 ]
            },
            {
              "t": 120,
              "s": [ 0 ]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 10
        },
        "p": {
          "a": 0,
          "k": [ 39.208, 68.881, 0 ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [ 39.208, 68.881, 0 ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 0,
          "k": [ 100, 100, 100 ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.055, -0.059 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.001, -0.102 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.046, -0.047 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.899, 0.313 ],
                    [ 1.802, 0.629 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.092, 0.046 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.501, -0.007 ],
                    [ 0.303, -0.225 ],
                    [ 0.09, -0.406 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.206, -0.294 ],
                    [ 0.001, -0.346 ],
                    [ -0.55, -0.309 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.316, -0.288 ],
                    [ -0.433, -0.001 ],
                    [ -0.318, 0.285 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.901, -0.315 ],
                    [ -1.797, -0.628 ],
                    [ 0, 0 ],
                    [ -0.186, 0 ],
                    [ -0.299, 0.299 ],
                    [ -0.001, 0.473 ],
                    [ 0.095, 0.215 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.002, 0.356 ],
                    [ 0.294, 0.309 ],
                    [ 0.476, -0.002 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ]
                  ],
                  "o": [
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.001, 0.091 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.047, 0.046 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.095, 0.001 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -1.797, -0.628 ],
                    [ -0.9, -0.314 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.009, -0.092 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.326, -0.485 ],
                    [ -0.366, 0.001 ],
                    [ -0.302, 0.223 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.375, 0.109 ],
                    [ -0.208, 0.294 ],
                    [ -0.009, 0.54 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.004, 0.48 ],
                    [ 0.315, 0.292 ],
                    [ 0.388, 0.003 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 1.801, 0.629 ],
                    [ 0.898, 0.313 ],
                    [ 0, 0 ],
                    [ 0.182, 0.064 ],
                    [ 0.474, -0.001 ],
                    [ 0.299, -0.299 ],
                    [ 0, -0.225 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.238, -0.301 ],
                    [ -0.001, -0.443 ],
                    [ -0.291, -0.31 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0, 0 ]
                  ],
                  "v": [
                    [ -1.108, -12.76 ],
                    [ -1.933, -12.195 ],
                    [ 3.214, -4.674 ],
                    [ 12.39, -5.643 ],
                    [ 12.363, -5.901 ],
                    [ 12.363, -5.641 ],
                    [ 12.39, -5.643 ],
                    [ 12.363, -5.901 ],
                    [ 12.363, -5.641 ],
                    [ 12.363, -5.971 ],
                    [ 12.126, -5.744 ],
                    [ 12.363, -5.641 ],
                    [ 12.363, -5.971 ],
                    [ 12.126, -5.744 ],
                    [ 12.356, -5.964 ],
                    [ 12.039, -5.964 ],
                    [ 12.126, -5.744 ],
                    [ 12.356, -5.964 ],
                    [ 12.039, -5.964 ],
                    [ 12.355, -5.964 ],
                    [ 12.103, -6.161 ],
                    [ 12.039, -5.964 ],
                    [ 12.355, -5.964 ],
                    [ 12.103, -6.161 ],
                    [ 6.419, 1.107 ],
                    [ 10.07, 9.458 ],
                    [ 10.363, 9.33 ],
                    [ 10.044, 9.33 ],
                    [ 10.07, 9.459 ],
                    [ 10.363, 9.33 ],
                    [ 10.044, 9.33 ],
                    [ 10.355, 9.33 ],
                    [ 10.132, 9.107 ],
                    [ 10.044, 9.33 ],
                    [ 10.355, 9.33 ],
                    [ 10.132, 9.107 ],
                    [ 10.349, 9.324 ],
                    [ 10.349, 9.02 ],
                    [ 10.132, 9.107 ],
                    [ 10.349, 9.324 ],
                    [ 10.349, 9.02 ],
                    [ 10.349, 9.317 ],
                    [ 10.447, 9.036 ],
                    [ 10.349, 9.02 ],
                    [ 10.349, 9.317 ],
                    [ 10.447, 9.036 ],
                    [ 10.448, 9.036 ],
                    [ 6.405, 7.624 ],
                    [ 2.352, 6.208 ],
                    [ 1.798, 6.015 ],
                    [ -5.115, 12.133 ],
                    [ -4.912, 12.363 ],
                    [ -4.912, 12.06 ],
                    [ -5.115, 12.133 ],
                    [ -4.912, 12.363 ],
                    [ -4.912, 12.06 ],
                    [ -4.912, 12.365 ],
                    [ -4.703, 12.142 ],
                    [ -4.912, 12.06 ],
                    [ -4.912, 12.365 ],
                    [ -4.703, 12.142 ],
                    [ -4.932, 12.387 ],
                    [ -4.594, 12.387 ],
                    [ -4.703, 12.142 ],
                    [ -4.932, 12.387 ],
                    [ -4.594, 12.387 ],
                    [ -4.871, 12.387 ],
                    [ -4.594, 12.398 ],
                    [ -4.594, 12.387 ],
                    [ -4.871, 12.387 ],
                    [ -4.594, 12.398 ],
                    [ -4.259, 3.247 ],
                    [ -12.196, -1.317 ],
                    [ -12.196, -1.317 ],
                    [ -12.361, -1.029 ],
                    [ -12.031, -1.029 ],
                    [ -12.196, -1.317 ],
                    [ -12.361, -1.029 ],
                    [ -12.031, -1.029 ],
                    [ -12.335, -1.029 ],
                    [ -12.088, -0.854 ],
                    [ -12.031, -1.029 ],
                    [ -12.335, -1.029 ],
                    [ -12.088, -0.854 ],
                    [ -12.335, -1.029 ],
                    [ -12.248, -0.735 ],
                    [ -12.088, -0.854 ],
                    [ -12.335, -1.029 ],
                    [ -12.248, -0.735 ],
                    [ -3.396, -3.356 ],
                    [ -1.375, -12.292 ],
                    [ -1.375, -12.292 ],
                    [ -1.679, -12.361 ],
                    [ -1.494, -12.113 ],
                    [ -1.375, -12.292 ],
                    [ -1.679, -12.361 ],
                    [ -1.494, -12.113 ],
                    [ -1.666, -12.343 ],
                    [ -1.666, -12.055 ],
                    [ -1.494, -12.113 ],
                    [ -1.666, -12.343 ],
                    [ -1.666, -12.055 ],
                    [ -1.666, -12.379 ],
                    [ -1.933, -12.196 ],
                    [ -1.666, -12.055 ],
                    [ -1.666, -12.379 ],
                    [ -1.933, -12.196 ],
                    [ -1.933, -12.195 ],
                    [ -1.108, -12.76 ],
                    [ -0.282, -13.325 ],
                    [ -1.666, -14.055 ],
                    [ -2.691, -13.715 ],
                    [ -3.325, -12.734 ],
                    [ -3.325, -12.734 ],
                    [ -5.088, -4.941 ],
                    [ -12.816, -2.653 ],
                    [ -13.719, -2.011 ],
                    [ -14.031, -1.029 ],
                    [ -13.193, 0.417 ],
                    [ -6.302, 4.38 ],
                    [ -6.593, 12.324 ],
                    [ -6.593, 12.323 ],
                    [ -6.594, 12.387 ],
                    [ -6.066, 13.606 ],
                    [ -4.912, 14.059 ],
                    [ -3.789, 13.631 ],
                    [ 2.685, 7.901 ],
                    [ 2.022, 7.152 ],
                    [ 1.692, 8.097 ],
                    [ 5.746, 9.513 ],
                    [ 9.788, 10.925 ],
                    [ 9.79, 10.925 ],
                    [ 10.349, 11.02 ],
                    [ 11.545, 10.522 ],
                    [ 12.044, 9.33 ],
                    [ 11.902, 8.657 ],
                    [ 8.729, 1.4 ],
                    [ 13.678, -4.929 ],
                    [ 14.039, -5.964 ],
                    [ 13.573, -7.125 ],
                    [ 12.363, -7.641 ],
                    [ 12.18, -7.632 ],
                    [ 4.191, -6.788 ],
                    [ -0.282, -13.325 ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [ 1, 0.999998922909, 1, 1 ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [ 39.204, 68.879 ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [ 0, 0 ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [ 100, 100 ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 3",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 91,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 5,
      "ty": 4,
      "nm": "s32",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 30.999,
              "s": [ 100 ]
            },
            {
              "i": {
                "x": [ 0.833 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.167 ],
                "y": [ 0 ]
              },
              "t": 47,
              "s": [ 0 ]
            },
            {
              "t": 120,
              "s": [ 0 ]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 22,
              "s": [ 0 ]
            },
            {
              "t": 47,
              "s": [ 50 ]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.337,
                "y": 1
              },
              "o": {
                "x": 0.191,
                "y": 0
              },
              "t": 22,
              "s": [ 53.208, 49.381, 0 ],
              "to": [ 7, 3.042, 0 ],
              "ti": [ 0, 0, 0 ]
            },
            {
              "t": 44,
              "s": [ 95.208, 67.631, 0 ]
            }
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [ 39.208, 68.881, 0 ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 22,
              "s": [ 0, 0, 100 ]
            },
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 29,
              "s": [ 16, 16, 100 ]
            },
            {
              "t": 44,
              "s": [ 8, 8, 100 ]
            }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [ -0.337, -0.493 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.372, -0.476 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.567, 0.197 ],
                    [ 0.898, 0.313 ],
                    [ 1.801, 0.629 ],
                    [ 0, 0 ],
                    [ -0.022, 0.599 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.581, 0.172 ],
                    [ 0, 0 ],
                    [ 0, 0 ]
                  ],
                  "o": [
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.601, -0.064 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.239, 0.547 ],
                    [ -1.797, -0.628 ],
                    [ -0.901, -0.314 ],
                    [ 0, 0 ],
                    [ -0.454, 0.401 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.519, -0.298 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.133, -0.585 ]
                  ],
                  "v": [
                    [ -1.133, -12.775 ],
                    [ 3.677, -5.746 ],
                    [ 12.26, -6.652 ],
                    [ 12.866, -5.561 ],
                    [ 7.549, 1.238 ],
                    [ 10.961, 9.042 ],
                    [ 10.094, 9.965 ],
                    [ 6.051, 8.553 ],
                    [ 1.997, 7.137 ],
                    [ -4.477, 12.867 ],
                    [ -5.618, 12.345 ],
                    [ -5.305, 3.798 ],
                    [ -12.719, -0.465 ],
                    [ -12.557, -1.709 ],
                    [ -4.267, -4.164 ],
                    [ -2.375, -12.528 ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [ 0.905205640606, 0.78973161286, 0.30304218367, 1 ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [ 39.229, 68.894 ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [ 0, 0 ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [ 100, 100 ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 17,
      "op": 91,
      "st": 17,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 6,
      "ty": 4,
      "nm": "s31",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 30.999,
              "s": [ 100 ]
            },
            {
              "i": {
                "x": [ 0.833 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.167 ],
                "y": [ 0 ]
              },
              "t": 47,
              "s": [ 0 ]
            },
            {
              "t": 120,
              "s": [ 0 ]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 22,
              "s": [ 0 ]
            },
            {
              "t": 47,
              "s": [ 50 ]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.337,
                "y": 1
              },
              "o": {
                "x": 0.191,
                "y": 0
              },
              "t": 22,
              "s": [ 53.208, 49.381, 0 ],
              "to": [ 4.75, 4.333, 0 ],
              "ti": [ 0, 0, 0 ]
            },
            {
              "t": 46,
              "s": [ 81.708, 75.381, 0 ]
            }
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [ 39.208, 68.881, 0 ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 22,
              "s": [ 0, 0, 100 ]
            },
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 31,
              "s": [ 15, 15, 100 ]
            },
            {
              "t": 44,
              "s": [ 8, 8, 100 ]
            }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [ -0.337, -0.493 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.372, -0.476 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.567, 0.197 ],
                    [ 0.898, 0.313 ],
                    [ 1.801, 0.629 ],
                    [ 0, 0 ],
                    [ -0.022, 0.599 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.581, 0.172 ],
                    [ 0, 0 ],
                    [ 0, 0 ]
                  ],
                  "o": [
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.601, -0.064 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.239, 0.547 ],
                    [ -1.797, -0.628 ],
                    [ -0.901, -0.314 ],
                    [ 0, 0 ],
                    [ -0.454, 0.401 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.519, -0.298 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.133, -0.585 ]
                  ],
                  "v": [
                    [ -1.133, -12.775 ],
                    [ 3.677, -5.746 ],
                    [ 12.26, -6.652 ],
                    [ 12.866, -5.561 ],
                    [ 7.549, 1.238 ],
                    [ 10.961, 9.042 ],
                    [ 10.094, 9.965 ],
                    [ 6.051, 8.553 ],
                    [ 1.997, 7.137 ],
                    [ -4.477, 12.867 ],
                    [ -5.618, 12.345 ],
                    [ -5.305, 3.798 ],
                    [ -12.719, -0.465 ],
                    [ -12.557, -1.709 ],
                    [ -4.267, -4.164 ],
                    [ -2.375, -12.528 ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [ 0.905205640606, 0.78973161286, 0.30304218367, 1 ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [ 39.229, 68.894 ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [ 0, 0 ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [ 100, 100 ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 17,
      "op": 91,
      "st": 17,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 7,
      "ty": 4,
      "nm": "s30",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 30.999,
              "s": [ 100 ]
            },
            {
              "i": {
                "x": [ 0.833 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.167 ],
                "y": [ 0 ]
              },
              "t": 47,
              "s": [ 0 ]
            },
            {
              "t": 120,
              "s": [ 0 ]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 22,
              "s": [ 0 ]
            },
            {
              "t": 47,
              "s": [ 50 ]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.337,
                "y": 1
              },
              "o": {
                "x": 0.191,
                "y": 0
              },
              "t": 22,
              "s": [ 53.208, 49.381, 0 ],
              "to": [ 3.125, 6.042, 0 ],
              "ti": [ 0, 0, 0 ]
            },
            {
              "t": 47,
              "s": [ 71.958, 85.631, 0 ]
            }
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [ 39.208, 68.881, 0 ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 22,
              "s": [ 0, 0, 100 ]
            },
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 26,
              "s": [ 12, 12, 100 ]
            },
            {
              "t": 44,
              "s": [ 8, 8, 100 ]
            }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [ -0.337, -0.493 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.372, -0.476 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.567, 0.197 ],
                    [ 0.898, 0.313 ],
                    [ 1.801, 0.629 ],
                    [ 0, 0 ],
                    [ -0.022, 0.599 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.581, 0.172 ],
                    [ 0, 0 ],
                    [ 0, 0 ]
                  ],
                  "o": [
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.601, -0.064 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.239, 0.547 ],
                    [ -1.797, -0.628 ],
                    [ -0.901, -0.314 ],
                    [ 0, 0 ],
                    [ -0.454, 0.401 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.519, -0.298 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.133, -0.585 ]
                  ],
                  "v": [
                    [ -1.133, -12.775 ],
                    [ 3.677, -5.746 ],
                    [ 12.26, -6.652 ],
                    [ 12.866, -5.561 ],
                    [ 7.549, 1.238 ],
                    [ 10.961, 9.042 ],
                    [ 10.094, 9.965 ],
                    [ 6.051, 8.553 ],
                    [ 1.997, 7.137 ],
                    [ -4.477, 12.867 ],
                    [ -5.618, 12.345 ],
                    [ -5.305, 3.798 ],
                    [ -12.719, -0.465 ],
                    [ -12.557, -1.709 ],
                    [ -4.267, -4.164 ],
                    [ -2.375, -12.528 ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [ 0.905205640606, 0.78973161286, 0.30304218367, 1 ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [ 39.229, 68.894 ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [ 0, 0 ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [ 100, 100 ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 17,
      "op": 91,
      "st": 17,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 8,
      "ty": 4,
      "nm": "s29",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 30.999,
              "s": [ 100 ]
            },
            {
              "i": {
                "x": [ 0.833 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.167 ],
                "y": [ 0 ]
              },
              "t": 47,
              "s": [ 0 ]
            },
            {
              "t": 120,
              "s": [ 0 ]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 22,
              "s": [ 0 ]
            },
            {
              "t": 47,
              "s": [ 50 ]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.337,
                "y": 1
              },
              "o": {
                "x": 0.191,
                "y": 0
              },
              "t": 22,
              "s": [ 53.208, 49.381, 0 ],
              "to": [ 0.458, 6.708, 0 ],
              "ti": [ 0, 0, 0 ]
            },
            {
              "t": 45,
              "s": [ 55.958, 89.631, 0 ]
            }
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [ 39.208, 68.881, 0 ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 22,
              "s": [ 0, 0, 100 ]
            },
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 28,
              "s": [ 10, 10, 100 ]
            },
            {
              "t": 44,
              "s": [ 8, 8, 100 ]
            }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [ -0.337, -0.493 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.372, -0.476 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.567, 0.197 ],
                    [ 0.898, 0.313 ],
                    [ 1.801, 0.629 ],
                    [ 0, 0 ],
                    [ -0.022, 0.599 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.581, 0.172 ],
                    [ 0, 0 ],
                    [ 0, 0 ]
                  ],
                  "o": [
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.601, -0.064 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.239, 0.547 ],
                    [ -1.797, -0.628 ],
                    [ -0.901, -0.314 ],
                    [ 0, 0 ],
                    [ -0.454, 0.401 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.519, -0.298 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.133, -0.585 ]
                  ],
                  "v": [
                    [ -1.133, -12.775 ],
                    [ 3.677, -5.746 ],
                    [ 12.26, -6.652 ],
                    [ 12.866, -5.561 ],
                    [ 7.549, 1.238 ],
                    [ 10.961, 9.042 ],
                    [ 10.094, 9.965 ],
                    [ 6.051, 8.553 ],
                    [ 1.997, 7.137 ],
                    [ -4.477, 12.867 ],
                    [ -5.618, 12.345 ],
                    [ -5.305, 3.798 ],
                    [ -12.719, -0.465 ],
                    [ -12.557, -1.709 ],
                    [ -4.267, -4.164 ],
                    [ -2.375, -12.528 ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [ 0.905205640606, 0.78973161286, 0.30304218367, 1 ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [ 39.229, 68.894 ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [ 0, 0 ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [ 100, 100 ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 17,
      "op": 91,
      "st": 17,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 9,
      "ty": 4,
      "nm": "s28",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 30.999,
              "s": [ 100 ]
            },
            {
              "i": {
                "x": [ 0.833 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.167 ],
                "y": [ 0 ]
              },
              "t": 47,
              "s": [ 0 ]
            },
            {
              "t": 120,
              "s": [ 0 ]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 22,
              "s": [ 0 ]
            },
            {
              "t": 47,
              "s": [ 50 ]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.337,
                "y": 1
              },
              "o": {
                "x": 0.191,
                "y": 0
              },
              "t": 22,
              "s": [ 53.208, 49.381, 0 ],
              "to": [ -2.5, 7.125, 0 ],
              "ti": [ 0, 0, 0 ]
            },
            {
              "t": 47,
              "s": [ 38.208, 92.131, 0 ]
            }
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [ 39.208, 68.881, 0 ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 22,
              "s": [ 0, 0, 100 ]
            },
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 32,
              "s": [ 14, 14, 100 ]
            },
            {
              "t": 44,
              "s": [ 8, 8, 100 ]
            }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [ -0.337, -0.493 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.372, -0.476 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.567, 0.197 ],
                    [ 0.898, 0.313 ],
                    [ 1.801, 0.629 ],
                    [ 0, 0 ],
                    [ -0.022, 0.599 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.581, 0.172 ],
                    [ 0, 0 ],
                    [ 0, 0 ]
                  ],
                  "o": [
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.601, -0.064 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.239, 0.547 ],
                    [ -1.797, -0.628 ],
                    [ -0.901, -0.314 ],
                    [ 0, 0 ],
                    [ -0.454, 0.401 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.519, -0.298 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.133, -0.585 ]
                  ],
                  "v": [
                    [ -1.133, -12.775 ],
                    [ 3.677, -5.746 ],
                    [ 12.26, -6.652 ],
                    [ 12.866, -5.561 ],
                    [ 7.549, 1.238 ],
                    [ 10.961, 9.042 ],
                    [ 10.094, 9.965 ],
                    [ 6.051, 8.553 ],
                    [ 1.997, 7.137 ],
                    [ -4.477, 12.867 ],
                    [ -5.618, 12.345 ],
                    [ -5.305, 3.798 ],
                    [ -12.719, -0.465 ],
                    [ -12.557, -1.709 ],
                    [ -4.267, -4.164 ],
                    [ -2.375, -12.528 ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [ 0.905205640606, 0.78973161286, 0.30304218367, 1 ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [ 39.229, 68.894 ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [ 0, 0 ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [ 100, 100 ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 17,
      "op": 91,
      "st": 17,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 10,
      "ty": 4,
      "nm": "s27",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 30.999,
              "s": [ 100 ]
            },
            {
              "i": {
                "x": [ 0.833 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.167 ],
                "y": [ 0 ]
              },
              "t": 47,
              "s": [ 0 ]
            },
            {
              "t": 120,
              "s": [ 0 ]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 22,
              "s": [ 0 ]
            },
            {
              "t": 47,
              "s": [ 50 ]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.337,
                "y": 1
              },
              "o": {
                "x": 0.191,
                "y": 0
              },
              "t": 22,
              "s": [ 53.208, 49.381, 0 ],
              "to": [ -4.792, 5.25, 0 ],
              "ti": [ 0, 0, 0 ]
            },
            {
              "t": 45,
              "s": [ 24.458, 80.881, 0 ]
            }
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [ 39.208, 68.881, 0 ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 22,
              "s": [ 0, 0, 100 ]
            },
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 27,
              "s": [ 17, 17, 100 ]
            },
            {
              "t": 44,
              "s": [ 8, 8, 100 ]
            }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [ -0.337, -0.493 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.372, -0.476 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.567, 0.197 ],
                    [ 0.898, 0.313 ],
                    [ 1.801, 0.629 ],
                    [ 0, 0 ],
                    [ -0.022, 0.599 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.581, 0.172 ],
                    [ 0, 0 ],
                    [ 0, 0 ]
                  ],
                  "o": [
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.601, -0.064 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.239, 0.547 ],
                    [ -1.797, -0.628 ],
                    [ -0.901, -0.314 ],
                    [ 0, 0 ],
                    [ -0.454, 0.401 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.519, -0.298 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.133, -0.585 ]
                  ],
                  "v": [
                    [ -1.133, -12.775 ],
                    [ 3.677, -5.746 ],
                    [ 12.26, -6.652 ],
                    [ 12.866, -5.561 ],
                    [ 7.549, 1.238 ],
                    [ 10.961, 9.042 ],
                    [ 10.094, 9.965 ],
                    [ 6.051, 8.553 ],
                    [ 1.997, 7.137 ],
                    [ -4.477, 12.867 ],
                    [ -5.618, 12.345 ],
                    [ -5.305, 3.798 ],
                    [ -12.719, -0.465 ],
                    [ -12.557, -1.709 ],
                    [ -4.267, -4.164 ],
                    [ -2.375, -12.528 ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [ 0.905205640606, 0.78973161286, 0.30304218367, 1 ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [ 39.229, 68.894 ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [ 0, 0 ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [ 100, 100 ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 17,
      "op": 91,
      "st": 17,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 11,
      "ty": 4,
      "nm": "s26",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 30.999,
              "s": [ 100 ]
            },
            {
              "i": {
                "x": [ 0.833 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.167 ],
                "y": [ 0 ]
              },
              "t": 47,
              "s": [ 0 ]
            },
            {
              "t": 120,
              "s": [ 0 ]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 22,
              "s": [ 0 ]
            },
            {
              "t": 47,
              "s": [ 50 ]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.337,
                "y": 1
              },
              "o": {
                "x": 0.191,
                "y": 0
              },
              "t": 22,
              "s": [ 53.208, 49.381, 0 ],
              "to": [ -5.833, 2.417, 0 ],
              "ti": [ 0, 0, 0 ]
            },
            {
              "t": 47,
              "s": [ 18.208, 63.881, 0 ]
            }
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [ 39.208, 68.881, 0 ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 22,
              "s": [ 0, 0, 100 ]
            },
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 28,
              "s": [ 11, 11, 100 ]
            },
            {
              "t": 44,
              "s": [ 8, 8, 100 ]
            }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [ -0.337, -0.493 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.372, -0.476 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.567, 0.197 ],
                    [ 0.898, 0.313 ],
                    [ 1.801, 0.629 ],
                    [ 0, 0 ],
                    [ -0.022, 0.599 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.581, 0.172 ],
                    [ 0, 0 ],
                    [ 0, 0 ]
                  ],
                  "o": [
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.601, -0.064 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.239, 0.547 ],
                    [ -1.797, -0.628 ],
                    [ -0.901, -0.314 ],
                    [ 0, 0 ],
                    [ -0.454, 0.401 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.519, -0.298 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.133, -0.585 ]
                  ],
                  "v": [
                    [ -1.133, -12.775 ],
                    [ 3.677, -5.746 ],
                    [ 12.26, -6.652 ],
                    [ 12.866, -5.561 ],
                    [ 7.549, 1.238 ],
                    [ 10.961, 9.042 ],
                    [ 10.094, 9.965 ],
                    [ 6.051, 8.553 ],
                    [ 1.997, 7.137 ],
                    [ -4.477, 12.867 ],
                    [ -5.618, 12.345 ],
                    [ -5.305, 3.798 ],
                    [ -12.719, -0.465 ],
                    [ -12.557, -1.709 ],
                    [ -4.267, -4.164 ],
                    [ -2.375, -12.528 ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [ 0.905205640606, 0.78973161286, 0.30304218367, 1 ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [ 39.229, 68.894 ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [ 0, 0 ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [ 100, 100 ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 17,
      "op": 91,
      "st": 17,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 12,
      "ty": 4,
      "nm": "s25",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 30.999,
              "s": [ 100 ]
            },
            {
              "i": {
                "x": [ 0.833 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.167 ],
                "y": [ 0 ]
              },
              "t": 47,
              "s": [ 0 ]
            },
            {
              "t": 120,
              "s": [ 0 ]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 22,
              "s": [ 0 ]
            },
            {
              "t": 47,
              "s": [ 50 ]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.337,
                "y": 1
              },
              "o": {
                "x": 0.191,
                "y": 0
              },
              "t": 22,
              "s": [ 53.208, 49.381, 0 ],
              "to": [ -7.667, -0.125, 0 ],
              "ti": [ 0, 0, 0 ]
            },
            {
              "t": 47,
              "s": [ 7.208, 48.631, 0 ]
            }
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [ 39.208, 68.881, 0 ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 22,
              "s": [ 0, 0, 100 ]
            },
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 33,
              "s": [ 13, 13, 100 ]
            },
            {
              "t": 44,
              "s": [ 8, 8, 100 ]
            }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [ -0.337, -0.493 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.372, -0.476 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.567, 0.197 ],
                    [ 0.898, 0.313 ],
                    [ 1.801, 0.629 ],
                    [ 0, 0 ],
                    [ -0.022, 0.599 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.581, 0.172 ],
                    [ 0, 0 ],
                    [ 0, 0 ]
                  ],
                  "o": [
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.601, -0.064 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.239, 0.547 ],
                    [ -1.797, -0.628 ],
                    [ -0.901, -0.314 ],
                    [ 0, 0 ],
                    [ -0.454, 0.401 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.519, -0.298 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.133, -0.585 ]
                  ],
                  "v": [
                    [ -1.133, -12.775 ],
                    [ 3.677, -5.746 ],
                    [ 12.26, -6.652 ],
                    [ 12.866, -5.561 ],
                    [ 7.549, 1.238 ],
                    [ 10.961, 9.042 ],
                    [ 10.094, 9.965 ],
                    [ 6.051, 8.553 ],
                    [ 1.997, 7.137 ],
                    [ -4.477, 12.867 ],
                    [ -5.618, 12.345 ],
                    [ -5.305, 3.798 ],
                    [ -12.719, -0.465 ],
                    [ -12.557, -1.709 ],
                    [ -4.267, -4.164 ],
                    [ -2.375, -12.528 ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [ 0.905205640606, 0.78973161286, 0.30304218367, 1 ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [ 39.229, 68.894 ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [ 0, 0 ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [ 100, 100 ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 17,
      "op": 91,
      "st": 17,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 13,
      "ty": 4,
      "nm": "s24",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 30.999,
              "s": [ 100 ]
            },
            {
              "i": {
                "x": [ 0.833 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.167 ],
                "y": [ 0 ]
              },
              "t": 47,
              "s": [ 0 ]
            },
            {
              "t": 120,
              "s": [ 0 ]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 22,
              "s": [ 0 ]
            },
            {
              "t": 47,
              "s": [ 50 ]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.337,
                "y": 1
              },
              "o": {
                "x": 0.191,
                "y": 0
              },
              "t": 22,
              "s": [ 53.208, 49.381, 0 ],
              "to": [ -6.208, -2.75, 0 ],
              "ti": [ 0, 0, 0 ]
            },
            {
              "t": 44,
              "s": [ 15.958, 32.881, 0 ]
            }
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [ 39.208, 68.881, 0 ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 22,
              "s": [ 0, 0, 100 ]
            },
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 35,
              "s": [ 15, 15, 100 ]
            },
            {
              "t": 44,
              "s": [ 8, 8, 100 ]
            }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [ -0.337, -0.493 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.372, -0.476 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.567, 0.197 ],
                    [ 0.898, 0.313 ],
                    [ 1.801, 0.629 ],
                    [ 0, 0 ],
                    [ -0.022, 0.599 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.581, 0.172 ],
                    [ 0, 0 ],
                    [ 0, 0 ]
                  ],
                  "o": [
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.601, -0.064 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.239, 0.547 ],
                    [ -1.797, -0.628 ],
                    [ -0.901, -0.314 ],
                    [ 0, 0 ],
                    [ -0.454, 0.401 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.519, -0.298 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.133, -0.585 ]
                  ],
                  "v": [
                    [ -1.133, -12.775 ],
                    [ 3.677, -5.746 ],
                    [ 12.26, -6.652 ],
                    [ 12.866, -5.561 ],
                    [ 7.549, 1.238 ],
                    [ 10.961, 9.042 ],
                    [ 10.094, 9.965 ],
                    [ 6.051, 8.553 ],
                    [ 1.997, 7.137 ],
                    [ -4.477, 12.867 ],
                    [ -5.618, 12.345 ],
                    [ -5.305, 3.798 ],
                    [ -12.719, -0.465 ],
                    [ -12.557, -1.709 ],
                    [ -4.267, -4.164 ],
                    [ -2.375, -12.528 ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [ 0.905205640606, 0.78973161286, 0.30304218367, 1 ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [ 39.229, 68.894 ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [ 0, 0 ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [ 100, 100 ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 17,
      "op": 91,
      "st": 17,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 14,
      "ty": 4,
      "nm": "s23",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 30.999,
              "s": [ 100 ]
            },
            {
              "i": {
                "x": [ 0.833 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.167 ],
                "y": [ 0 ]
              },
              "t": 47,
              "s": [ 0 ]
            },
            {
              "t": 120,
              "s": [ 0 ]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 22,
              "s": [ 0 ]
            },
            {
              "t": 47,
              "s": [ 50 ]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.337,
                "y": 1
              },
              "o": {
                "x": 0.191,
                "y": 0
              },
              "t": 22,
              "s": [ 53.208, 49.381, 0 ],
              "to": [ -5.333, -4.75, 0 ],
              "ti": [ 0, 0, 0 ]
            },
            {
              "t": 46,
              "s": [ 21.208, 20.881, 0 ]
            }
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [ 39.208, 68.881, 0 ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 22,
              "s": [ 0, 0, 100 ]
            },
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 31,
              "s": [ 10, 10, 100 ]
            },
            {
              "t": 44,
              "s": [ 8, 8, 100 ]
            }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [ -0.337, -0.493 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.372, -0.476 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.567, 0.197 ],
                    [ 0.898, 0.313 ],
                    [ 1.801, 0.629 ],
                    [ 0, 0 ],
                    [ -0.022, 0.599 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.581, 0.172 ],
                    [ 0, 0 ],
                    [ 0, 0 ]
                  ],
                  "o": [
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.601, -0.064 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.239, 0.547 ],
                    [ -1.797, -0.628 ],
                    [ -0.901, -0.314 ],
                    [ 0, 0 ],
                    [ -0.454, 0.401 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.519, -0.298 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.133, -0.585 ]
                  ],
                  "v": [
                    [ -1.133, -12.775 ],
                    [ 3.677, -5.746 ],
                    [ 12.26, -6.652 ],
                    [ 12.866, -5.561 ],
                    [ 7.549, 1.238 ],
                    [ 10.961, 9.042 ],
                    [ 10.094, 9.965 ],
                    [ 6.051, 8.553 ],
                    [ 1.997, 7.137 ],
                    [ -4.477, 12.867 ],
                    [ -5.618, 12.345 ],
                    [ -5.305, 3.798 ],
                    [ -12.719, -0.465 ],
                    [ -12.557, -1.709 ],
                    [ -4.267, -4.164 ],
                    [ -2.375, -12.528 ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [ 0.905205640606, 0.78973161286, 0.30304218367, 1 ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [ 39.229, 68.894 ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [ 0, 0 ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [ 100, 100 ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 17,
      "op": 91,
      "st": 17,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 15,
      "ty": 4,
      "nm": "s22",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 30.999,
              "s": [ 100 ]
            },
            {
              "i": {
                "x": [ 0.833 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.167 ],
                "y": [ 0 ]
              },
              "t": 47,
              "s": [ 0 ]
            },
            {
              "t": 120,
              "s": [ 0 ]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 22,
              "s": [ 0 ]
            },
            {
              "t": 47,
              "s": [ 50 ]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.337,
                "y": 1
              },
              "o": {
                "x": 0.191,
                "y": 0
              },
              "t": 22,
              "s": [ 53.208, 49.381, 0 ],
              "to": [ -2.833, -6.167, 0 ],
              "ti": [ 0, 0, 0 ]
            },
            {
              "t": 48,
              "s": [ 36.208, 12.381, 0 ]
            }
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [ 39.208, 68.881, 0 ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 22,
              "s": [ 0, 0, 100 ]
            },
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 32,
              "s": [ 13, 13, 100 ]
            },
            {
              "t": 44,
              "s": [ 8, 8, 100 ]
            }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [ -0.337, -0.493 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.372, -0.476 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.567, 0.197 ],
                    [ 0.898, 0.313 ],
                    [ 1.801, 0.629 ],
                    [ 0, 0 ],
                    [ -0.022, 0.599 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.581, 0.172 ],
                    [ 0, 0 ],
                    [ 0, 0 ]
                  ],
                  "o": [
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.601, -0.064 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.239, 0.547 ],
                    [ -1.797, -0.628 ],
                    [ -0.901, -0.314 ],
                    [ 0, 0 ],
                    [ -0.454, 0.401 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.519, -0.298 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.133, -0.585 ]
                  ],
                  "v": [
                    [ -1.133, -12.775 ],
                    [ 3.677, -5.746 ],
                    [ 12.26, -6.652 ],
                    [ 12.866, -5.561 ],
                    [ 7.549, 1.238 ],
                    [ 10.961, 9.042 ],
                    [ 10.094, 9.965 ],
                    [ 6.051, 8.553 ],
                    [ 1.997, 7.137 ],
                    [ -4.477, 12.867 ],
                    [ -5.618, 12.345 ],
                    [ -5.305, 3.798 ],
                    [ -12.719, -0.465 ],
                    [ -12.557, -1.709 ],
                    [ -4.267, -4.164 ],
                    [ -2.375, -12.528 ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [ 0.905205640606, 0.78973161286, 0.30304218367, 1 ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [ 39.229, 68.894 ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [ 0, 0 ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [ 100, 100 ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 17,
      "op": 91,
      "st": 17,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 16,
      "ty": 4,
      "nm": "s21",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 30.999,
              "s": [ 100 ]
            },
            {
              "i": {
                "x": [ 0.833 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.167 ],
                "y": [ 0 ]
              },
              "t": 47,
              "s": [ 0 ]
            },
            {
              "t": 120,
              "s": [ 0 ]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 22,
              "s": [ 0 ]
            },
            {
              "t": 47,
              "s": [ 50 ]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.337,
                "y": 1
              },
              "o": {
                "x": 0.191,
                "y": 0
              },
              "t": 22,
              "s": [ 53.208, 49.381, 0 ],
              "to": [ -0.167, -7.542, 0 ],
              "ti": [ 0, 0, 0 ]
            },
            {
              "t": 44,
              "s": [ 52.208, 4.131, 0 ]
            }
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [ 39.208, 68.881, 0 ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 22,
              "s": [ 0, 0, 100 ]
            },
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 26,
              "s": [ 22, 22, 100 ]
            },
            {
              "t": 44,
              "s": [ 8, 8, 100 ]
            }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [ -0.337, -0.493 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.372, -0.476 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.567, 0.197 ],
                    [ 0.898, 0.313 ],
                    [ 1.801, 0.629 ],
                    [ 0, 0 ],
                    [ -0.022, 0.599 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.581, 0.172 ],
                    [ 0, 0 ],
                    [ 0, 0 ]
                  ],
                  "o": [
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.601, -0.064 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.239, 0.547 ],
                    [ -1.797, -0.628 ],
                    [ -0.901, -0.314 ],
                    [ 0, 0 ],
                    [ -0.454, 0.401 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.519, -0.298 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.133, -0.585 ]
                  ],
                  "v": [
                    [ -1.133, -12.775 ],
                    [ 3.677, -5.746 ],
                    [ 12.26, -6.652 ],
                    [ 12.866, -5.561 ],
                    [ 7.549, 1.238 ],
                    [ 10.961, 9.042 ],
                    [ 10.094, 9.965 ],
                    [ 6.051, 8.553 ],
                    [ 1.997, 7.137 ],
                    [ -4.477, 12.867 ],
                    [ -5.618, 12.345 ],
                    [ -5.305, 3.798 ],
                    [ -12.719, -0.465 ],
                    [ -12.557, -1.709 ],
                    [ -4.267, -4.164 ],
                    [ -2.375, -12.528 ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [ 0.905205640606, 0.78973161286, 0.30304218367, 1 ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [ 39.229, 68.894 ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [ 0, 0 ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [ 100, 100 ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 17,
      "op": 91,
      "st": 17,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 17,
      "ty": 4,
      "nm": "s20",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 30.999,
              "s": [ 100 ]
            },
            {
              "i": {
                "x": [ 0.833 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.167 ],
                "y": [ 0 ]
              },
              "t": 47,
              "s": [ 0 ]
            },
            {
              "t": 120,
              "s": [ 0 ]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 22,
              "s": [ 0 ]
            },
            {
              "t": 47,
              "s": [ 50 ]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.337,
                "y": 1
              },
              "o": {
                "x": 0.191,
                "y": 0
              },
              "t": 22,
              "s": [ 53.208, 49.381, 0 ],
              "to": [ 2.625, -6.667, 0 ],
              "ti": [ 0, 0, 0 ]
            },
            {
              "t": 47,
              "s": [ 68.958, 9.381, 0 ]
            }
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [ 39.208, 68.881, 0 ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 22,
              "s": [ -13, -13, 100 ]
            },
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 32,
              "s": [ 9, 9, 100 ]
            },
            {
              "t": 44,
              "s": [ -5, -5, 100 ]
            }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [ -0.337, -0.493 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.372, -0.476 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.567, 0.197 ],
                    [ 0.898, 0.313 ],
                    [ 1.801, 0.629 ],
                    [ 0, 0 ],
                    [ -0.022, 0.599 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.581, 0.172 ],
                    [ 0, 0 ],
                    [ 0, 0 ]
                  ],
                  "o": [
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.601, -0.064 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.239, 0.547 ],
                    [ -1.797, -0.628 ],
                    [ -0.901, -0.314 ],
                    [ 0, 0 ],
                    [ -0.454, 0.401 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.519, -0.298 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.133, -0.585 ]
                  ],
                  "v": [
                    [ -1.133, -12.775 ],
                    [ 3.677, -5.746 ],
                    [ 12.26, -6.652 ],
                    [ 12.866, -5.561 ],
                    [ 7.549, 1.238 ],
                    [ 10.961, 9.042 ],
                    [ 10.094, 9.965 ],
                    [ 6.051, 8.553 ],
                    [ 1.997, 7.137 ],
                    [ -4.477, 12.867 ],
                    [ -5.618, 12.345 ],
                    [ -5.305, 3.798 ],
                    [ -12.719, -0.465 ],
                    [ -12.557, -1.709 ],
                    [ -4.267, -4.164 ],
                    [ -2.375, -12.528 ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [ 0.905205640606, 0.78973161286, 0.30304218367, 1 ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [ 39.229, 68.894 ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [ 0, 0 ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [ 100, 100 ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 17,
      "op": 91,
      "st": 17,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 18,
      "ty": 4,
      "nm": "s19",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 30.999,
              "s": [ 100 ]
            },
            {
              "i": {
                "x": [ 0.833 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.167 ],
                "y": [ 0 ]
              },
              "t": 47,
              "s": [ 0 ]
            },
            {
              "t": 120,
              "s": [ 0 ]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 22,
              "s": [ 0 ]
            },
            {
              "t": 47,
              "s": [ 50 ]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.337,
                "y": 1
              },
              "o": {
                "x": 0.191,
                "y": 0
              },
              "t": 22,
              "s": [ 53.208, 49.381, 0 ],
              "to": [ 4.875, -4.75, 0 ],
              "ti": [ 0, 0, 0 ]
            },
            {
              "t": 45,
              "s": [ 82.458, 20.881, 0 ]
            }
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [ 39.208, 68.881, 0 ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 22,
              "s": [ 0, 0, 100 ]
            },
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 34,
              "s": [ 15, 15, 100 ]
            },
            {
              "t": 44,
              "s": [ 8, 8, 100 ]
            }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [ -0.337, -0.493 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.372, -0.476 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.567, 0.197 ],
                    [ 0.898, 0.313 ],
                    [ 1.801, 0.629 ],
                    [ 0, 0 ],
                    [ -0.022, 0.599 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.581, 0.172 ],
                    [ 0, 0 ],
                    [ 0, 0 ]
                  ],
                  "o": [
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.601, -0.064 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.239, 0.547 ],
                    [ -1.797, -0.628 ],
                    [ -0.901, -0.314 ],
                    [ 0, 0 ],
                    [ -0.454, 0.401 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.519, -0.298 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.133, -0.585 ]
                  ],
                  "v": [
                    [ -1.133, -12.775 ],
                    [ 3.677, -5.746 ],
                    [ 12.26, -6.652 ],
                    [ 12.866, -5.561 ],
                    [ 7.549, 1.238 ],
                    [ 10.961, 9.042 ],
                    [ 10.094, 9.965 ],
                    [ 6.051, 8.553 ],
                    [ 1.997, 7.137 ],
                    [ -4.477, 12.867 ],
                    [ -5.618, 12.345 ],
                    [ -5.305, 3.798 ],
                    [ -12.719, -0.465 ],
                    [ -12.557, -1.709 ],
                    [ -4.267, -4.164 ],
                    [ -2.375, -12.528 ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [ 0.905205640606, 0.78973161286, 0.30304218367, 1 ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [ 39.229, 68.894 ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [ 0, 0 ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [ 100, 100 ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 17,
      "op": 91,
      "st": 17,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 19,
      "ty": 4,
      "nm": "s18",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 30.999,
              "s": [ 100 ]
            },
            {
              "i": {
                "x": [ 0.833 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.167 ],
                "y": [ 0 ]
              },
              "t": 47,
              "s": [ 0 ]
            },
            {
              "t": 120,
              "s": [ 0 ]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 22,
              "s": [ 0 ]
            },
            {
              "t": 47,
              "s": [ 50 ]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.337,
                "y": 1
              },
              "o": {
                "x": 0.191,
                "y": 0
              },
              "t": 22,
              "s": [ 53.208, 49.381, 0 ],
              "to": [ 6.583, -3.125, 0 ],
              "ti": [ 0, 0, 0 ]
            },
            {
              "t": 47,
              "s": [ 92.708, 30.631, 0 ]
            }
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [ 39.208, 68.881, 0 ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 22,
              "s": [ 0, 0, 100 ]
            },
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 32,
              "s": [ 15, 15, 100 ]
            },
            {
              "t": 44,
              "s": [ 8, 8, 100 ]
            }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [ -0.337, -0.493 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.372, -0.476 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.567, 0.197 ],
                    [ 0.898, 0.313 ],
                    [ 1.801, 0.629 ],
                    [ 0, 0 ],
                    [ -0.022, 0.599 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.581, 0.172 ],
                    [ 0, 0 ],
                    [ 0, 0 ]
                  ],
                  "o": [
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.601, -0.064 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.239, 0.547 ],
                    [ -1.797, -0.628 ],
                    [ -0.901, -0.314 ],
                    [ 0, 0 ],
                    [ -0.454, 0.401 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.519, -0.298 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.133, -0.585 ]
                  ],
                  "v": [
                    [ -1.133, -12.775 ],
                    [ 3.677, -5.746 ],
                    [ 12.26, -6.652 ],
                    [ 12.866, -5.561 ],
                    [ 7.549, 1.238 ],
                    [ 10.961, 9.042 ],
                    [ 10.094, 9.965 ],
                    [ 6.051, 8.553 ],
                    [ 1.997, 7.137 ],
                    [ -4.477, 12.867 ],
                    [ -5.618, 12.345 ],
                    [ -5.305, 3.798 ],
                    [ -12.719, -0.465 ],
                    [ -12.557, -1.709 ],
                    [ -4.267, -4.164 ],
                    [ -2.375, -12.528 ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [ 0.905205640606, 0.78973161286, 0.30304218367, 1 ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [ 39.229, 68.894 ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [ 0, 0 ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [ 100, 100 ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 17,
      "op": 91,
      "st": 17,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 20,
      "ty": 4,
      "nm": "s17",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 30.999,
              "s": [ 100 ]
            },
            {
              "i": {
                "x": [ 0.833 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.167 ],
                "y": [ 0 ]
              },
              "t": 47,
              "s": [ 0 ]
            },
            {
              "t": 120,
              "s": [ 0 ]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 22,
              "s": [ 0 ]
            },
            {
              "t": 47,
              "s": [ 50 ]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.337,
                "y": 1
              },
              "o": {
                "x": 0.191,
                "y": 0
              },
              "t": 22,
              "s": [ 53.208, 49.381, 0 ],
              "to": [ 6.333, -0.042, 0 ],
              "ti": [ -6.333, 0.042, 0 ]
            },
            {
              "t": 45,
              "s": [ 91.208, 49.131, 0 ]
            }
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [ 39.208, 68.881, 0 ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 22,
              "s": [ 0, 0, 100 ]
            },
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 26,
              "s": [ 16, 16, 100 ]
            },
            {
              "t": 44,
              "s": [ 8, 8, 100 ]
            }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [ -0.337, -0.493 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.372, -0.476 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.567, 0.197 ],
                    [ 0.898, 0.313 ],
                    [ 1.801, 0.629 ],
                    [ 0, 0 ],
                    [ -0.022, 0.599 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.581, 0.172 ],
                    [ 0, 0 ],
                    [ 0, 0 ]
                  ],
                  "o": [
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.601, -0.064 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.239, 0.547 ],
                    [ -1.797, -0.628 ],
                    [ -0.901, -0.314 ],
                    [ 0, 0 ],
                    [ -0.454, 0.401 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.519, -0.298 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.133, -0.585 ]
                  ],
                  "v": [
                    [ -1.133, -12.775 ],
                    [ 3.677, -5.746 ],
                    [ 12.26, -6.652 ],
                    [ 12.866, -5.561 ],
                    [ 7.549, 1.238 ],
                    [ 10.961, 9.042 ],
                    [ 10.094, 9.965 ],
                    [ 6.051, 8.553 ],
                    [ 1.997, 7.137 ],
                    [ -4.477, 12.867 ],
                    [ -5.618, 12.345 ],
                    [ -5.305, 3.798 ],
                    [ -12.719, -0.465 ],
                    [ -12.557, -1.709 ],
                    [ -4.267, -4.164 ],
                    [ -2.375, -12.528 ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [ 0.905205640606, 0.78973161286, 0.30304218367, 1 ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [ 39.229, 68.894 ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [ 0, 0 ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [ 100, 100 ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 17,
      "op": 91,
      "st": 17,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 21,
      "ty": 4,
      "nm": "s16",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 20.999,
              "s": [ 100 ]
            },
            {
              "i": {
                "x": [ 0.833 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.167 ],
                "y": [ 0 ]
              },
              "t": 37,
              "s": [ 0 ]
            },
            {
              "t": 120,
              "s": [ 0 ]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 7,
              "s": [ 0 ]
            },
            {
              "t": 37,
              "s": [ 50 ]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.337,
                "y": 1
              },
              "o": {
                "x": 0.191,
                "y": 0
              },
              "t": 7,
              "s": [ 53.208, 49.381, 0 ],
              "to": [ 5.292, 2.5, 0 ],
              "ti": [ 0, 0, 0 ]
            },
            {
              "t": 37,
              "s": [ 84.958, 64.381, 0 ]
            }
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [ 39.208, 68.881, 0 ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 7,
              "s": [ 0, 0, 100 ]
            },
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 20.999,
              "s": [ 24, 24, 100 ]
            },
            {
              "t": 34,
              "s": [ 27, 27, 100 ]
            }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [ -0.337, -0.493 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.372, -0.476 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.567, 0.197 ],
                    [ 0.898, 0.313 ],
                    [ 1.801, 0.629 ],
                    [ 0, 0 ],
                    [ -0.022, 0.599 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.581, 0.172 ],
                    [ 0, 0 ],
                    [ 0, 0 ]
                  ],
                  "o": [
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.601, -0.064 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.239, 0.547 ],
                    [ -1.797, -0.628 ],
                    [ -0.901, -0.314 ],
                    [ 0, 0 ],
                    [ -0.454, 0.401 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.519, -0.298 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.133, -0.585 ]
                  ],
                  "v": [
                    [ -1.133, -12.775 ],
                    [ 3.677, -5.746 ],
                    [ 12.26, -6.652 ],
                    [ 12.866, -5.561 ],
                    [ 7.549, 1.238 ],
                    [ 10.961, 9.042 ],
                    [ 10.094, 9.965 ],
                    [ 6.051, 8.553 ],
                    [ 1.997, 7.137 ],
                    [ -4.477, 12.867 ],
                    [ -5.618, 12.345 ],
                    [ -5.305, 3.798 ],
                    [ -12.719, -0.465 ],
                    [ -12.557, -1.709 ],
                    [ -4.267, -4.164 ],
                    [ -2.375, -12.528 ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [ 0.905205640606, 0.78973161286, 0.30304218367, 1 ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [ 39.229, 68.894 ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [ 0, 0 ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [ 100, 100 ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 7,
      "op": 91,
      "st": 7,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 22,
      "ty": 4,
      "nm": "s15",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 20.999,
              "s": [ 100 ]
            },
            {
              "i": {
                "x": [ 0.833 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.167 ],
                "y": [ 0 ]
              },
              "t": 37,
              "s": [ 0 ]
            },
            {
              "t": 120,
              "s": [ 0 ]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 7,
              "s": [ 0 ]
            },
            {
              "t": 37,
              "s": [ 50 ]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.337,
                "y": 1
              },
              "o": {
                "x": 0.191,
                "y": 0
              },
              "t": 7,
              "s": [ 53.208, 49.381, 0 ],
              "to": [ 5.125, 5.125, 0 ],
              "ti": [ 0, 0, 0 ]
            },
            {
              "t": 34,
              "s": [ 83.958, 80.131, 0 ]
            }
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [ 39.208, 68.881, 0 ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 7,
              "s": [ 0, 0, 100 ]
            },
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 20.999,
              "s": [ 24, 24, 100 ]
            },
            {
              "t": 34,
              "s": [ 27, 27, 100 ]
            }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [ -0.337, -0.493 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.372, -0.476 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.567, 0.197 ],
                    [ 0.898, 0.313 ],
                    [ 1.801, 0.629 ],
                    [ 0, 0 ],
                    [ -0.022, 0.599 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.581, 0.172 ],
                    [ 0, 0 ],
                    [ 0, 0 ]
                  ],
                  "o": [
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.601, -0.064 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.239, 0.547 ],
                    [ -1.797, -0.628 ],
                    [ -0.901, -0.314 ],
                    [ 0, 0 ],
                    [ -0.454, 0.401 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.519, -0.298 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.133, -0.585 ]
                  ],
                  "v": [
                    [ -1.133, -12.775 ],
                    [ 3.677, -5.746 ],
                    [ 12.26, -6.652 ],
                    [ 12.866, -5.561 ],
                    [ 7.549, 1.238 ],
                    [ 10.961, 9.042 ],
                    [ 10.094, 9.965 ],
                    [ 6.051, 8.553 ],
                    [ 1.997, 7.137 ],
                    [ -4.477, 12.867 ],
                    [ -5.618, 12.345 ],
                    [ -5.305, 3.798 ],
                    [ -12.719, -0.465 ],
                    [ -12.557, -1.709 ],
                    [ -4.267, -4.164 ],
                    [ -2.375, -12.528 ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [ 0.905205640606, 0.78973161286, 0.30304218367, 1 ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [ 39.229, 68.894 ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [ 0, 0 ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [ 100, 100 ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 7,
      "op": 91,
      "st": 7,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 23,
      "ty": 4,
      "nm": "s14",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 20.999,
              "s": [ 100 ]
            },
            {
              "i": {
                "x": [ 0.833 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.167 ],
                "y": [ 0 ]
              },
              "t": 37,
              "s": [ 0 ]
            },
            {
              "t": 120,
              "s": [ 0 ]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 7,
              "s": [ 0 ]
            },
            {
              "t": 37,
              "s": [ 50 ]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.337,
                "y": 1
              },
              "o": {
                "x": 0.191,
                "y": 0
              },
              "t": 17,
              "s": [ 53.208, 49.381, 0 ],
              "to": [ 3.25, 6.208, 0 ],
              "ti": [ 0, 0, 0 ]
            },
            {
              "t": 36,
              "s": [ 72.708, 86.631, 0 ]
            }
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [ 39.208, 68.881, 0 ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 7,
              "s": [ 0, 0, 100 ]
            },
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 20.999,
              "s": [ 24, 24, 100 ]
            },
            {
              "t": 34,
              "s": [ 27, 27, 100 ]
            }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [ -0.337, -0.493 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.372, -0.476 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.567, 0.197 ],
                    [ 0.898, 0.313 ],
                    [ 1.801, 0.629 ],
                    [ 0, 0 ],
                    [ -0.022, 0.599 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.581, 0.172 ],
                    [ 0, 0 ],
                    [ 0, 0 ]
                  ],
                  "o": [
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.601, -0.064 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.239, 0.547 ],
                    [ -1.797, -0.628 ],
                    [ -0.901, -0.314 ],
                    [ 0, 0 ],
                    [ -0.454, 0.401 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.519, -0.298 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.133, -0.585 ]
                  ],
                  "v": [
                    [ -1.133, -12.775 ],
                    [ 3.677, -5.746 ],
                    [ 12.26, -6.652 ],
                    [ 12.866, -5.561 ],
                    [ 7.549, 1.238 ],
                    [ 10.961, 9.042 ],
                    [ 10.094, 9.965 ],
                    [ 6.051, 8.553 ],
                    [ 1.997, 7.137 ],
                    [ -4.477, 12.867 ],
                    [ -5.618, 12.345 ],
                    [ -5.305, 3.798 ],
                    [ -12.719, -0.465 ],
                    [ -12.557, -1.709 ],
                    [ -4.267, -4.164 ],
                    [ -2.375, -12.528 ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [ 0.905205640606, 0.78973161286, 0.30304218367, 1 ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [ 39.229, 68.894 ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [ 0, 0 ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [ 100, 100 ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 7,
      "op": 91,
      "st": 7,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 24,
      "ty": 4,
      "nm": "s13",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 20.999,
              "s": [ 100 ]
            },
            {
              "i": {
                "x": [ 0.833 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.167 ],
                "y": [ 0 ]
              },
              "t": 37,
              "s": [ 0 ]
            },
            {
              "t": 120,
              "s": [ 0 ]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 7,
              "s": [ 0 ]
            },
            {
              "t": 37,
              "s": [ 50 ]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.337,
                "y": 1
              },
              "o": {
                "x": 0.191,
                "y": 0
              },
              "t": 15,
              "s": [ 53.208, 49.381, 0 ],
              "to": [ 0.625, 7.083, 0 ],
              "ti": [ 0, 0, 0 ]
            },
            {
              "t": 37,
              "s": [ 56.958, 91.881, 0 ]
            }
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [ 39.208, 68.881, 0 ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 7,
              "s": [ 0, 0, 100 ]
            },
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 20.999,
              "s": [ 24, 24, 100 ]
            },
            {
              "t": 34,
              "s": [ 27, 27, 100 ]
            }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [ -0.337, -0.493 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.372, -0.476 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.567, 0.197 ],
                    [ 0.898, 0.313 ],
                    [ 1.801, 0.629 ],
                    [ 0, 0 ],
                    [ -0.022, 0.599 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.581, 0.172 ],
                    [ 0, 0 ],
                    [ 0, 0 ]
                  ],
                  "o": [
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.601, -0.064 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.239, 0.547 ],
                    [ -1.797, -0.628 ],
                    [ -0.901, -0.314 ],
                    [ 0, 0 ],
                    [ -0.454, 0.401 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.519, -0.298 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.133, -0.585 ]
                  ],
                  "v": [
                    [ -1.133, -12.775 ],
                    [ 3.677, -5.746 ],
                    [ 12.26, -6.652 ],
                    [ 12.866, -5.561 ],
                    [ 7.549, 1.238 ],
                    [ 10.961, 9.042 ],
                    [ 10.094, 9.965 ],
                    [ 6.051, 8.553 ],
                    [ 1.997, 7.137 ],
                    [ -4.477, 12.867 ],
                    [ -5.618, 12.345 ],
                    [ -5.305, 3.798 ],
                    [ -12.719, -0.465 ],
                    [ -12.557, -1.709 ],
                    [ -4.267, -4.164 ],
                    [ -2.375, -12.528 ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [ 0.905205640606, 0.78973161286, 0.30304218367, 1 ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [ 39.229, 68.894 ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [ 0, 0 ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [ 100, 100 ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 7,
      "op": 91,
      "st": 7,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 25,
      "ty": 4,
      "nm": "s12",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 20.999,
              "s": [ 100 ]
            },
            {
              "i": {
                "x": [ 0.833 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.167 ],
                "y": [ 0 ]
              },
              "t": 37,
              "s": [ 0 ]
            },
            {
              "t": 120,
              "s": [ 0 ]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 7,
              "s": [ 0 ]
            },
            {
              "t": 37,
              "s": [ 50 ]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.337,
                "y": 1
              },
              "o": {
                "x": 0.191,
                "y": 0
              },
              "t": 7,
              "s": [ 53.208, 49.381, 0 ],
              "to": [ -1.625, 5.042, 0 ],
              "ti": [ 0, 0, 0 ]
            },
            {
              "t": 36,
              "s": [ 43.458, 79.631, 0 ]
            }
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [ 39.208, 68.881, 0 ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 7,
              "s": [ 0, 0, 100 ]
            },
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 20.999,
              "s": [ 24, 24, 100 ]
            },
            {
              "t": 34,
              "s": [ 27, 27, 100 ]
            }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [ -0.337, -0.493 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.372, -0.476 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.567, 0.197 ],
                    [ 0.898, 0.313 ],
                    [ 1.801, 0.629 ],
                    [ 0, 0 ],
                    [ -0.022, 0.599 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.581, 0.172 ],
                    [ 0, 0 ],
                    [ 0, 0 ]
                  ],
                  "o": [
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.601, -0.064 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.239, 0.547 ],
                    [ -1.797, -0.628 ],
                    [ -0.901, -0.314 ],
                    [ 0, 0 ],
                    [ -0.454, 0.401 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.519, -0.298 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.133, -0.585 ]
                  ],
                  "v": [
                    [ -1.133, -12.775 ],
                    [ 3.677, -5.746 ],
                    [ 12.26, -6.652 ],
                    [ 12.866, -5.561 ],
                    [ 7.549, 1.238 ],
                    [ 10.961, 9.042 ],
                    [ 10.094, 9.965 ],
                    [ 6.051, 8.553 ],
                    [ 1.997, 7.137 ],
                    [ -4.477, 12.867 ],
                    [ -5.618, 12.345 ],
                    [ -5.305, 3.798 ],
                    [ -12.719, -0.465 ],
                    [ -12.557, -1.709 ],
                    [ -4.267, -4.164 ],
                    [ -2.375, -12.528 ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [ 0.905205640606, 0.78973161286, 0.30304218367, 1 ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [ 39.229, 68.894 ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [ 0, 0 ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [ 100, 100 ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 7,
      "op": 91,
      "st": 7,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 26,
      "ty": 4,
      "nm": "s11",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 20.999,
              "s": [ 100 ]
            },
            {
              "i": {
                "x": [ 0.833 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.167 ],
                "y": [ 0 ]
              },
              "t": 37,
              "s": [ 0 ]
            },
            {
              "t": 120,
              "s": [ 0 ]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 7,
              "s": [ 0 ]
            },
            {
              "t": 37,
              "s": [ 50 ]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.337,
                "y": 1
              },
              "o": {
                "x": 0.191,
                "y": 0
              },
              "t": 16,
              "s": [ 53.208, 49.381, 0 ],
              "to": [ -4.083, 4.75, 0 ],
              "ti": [ 0, 0, 0 ]
            },
            {
              "t": 37,
              "s": [ 28.708, 77.881, 0 ]
            }
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [ 39.208, 68.881, 0 ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 7,
              "s": [ 0, 0, 100 ]
            },
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 20.999,
              "s": [ 24, 24, 100 ]
            },
            {
              "t": 34,
              "s": [ 27, 27, 100 ]
            }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [ -0.337, -0.493 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.372, -0.476 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.567, 0.197 ],
                    [ 0.898, 0.313 ],
                    [ 1.801, 0.629 ],
                    [ 0, 0 ],
                    [ -0.022, 0.599 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.581, 0.172 ],
                    [ 0, 0 ],
                    [ 0, 0 ]
                  ],
                  "o": [
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.601, -0.064 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.239, 0.547 ],
                    [ -1.797, -0.628 ],
                    [ -0.901, -0.314 ],
                    [ 0, 0 ],
                    [ -0.454, 0.401 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.519, -0.298 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.133, -0.585 ]
                  ],
                  "v": [
                    [ -1.133, -12.775 ],
                    [ 3.677, -5.746 ],
                    [ 12.26, -6.652 ],
                    [ 12.866, -5.561 ],
                    [ 7.549, 1.238 ],
                    [ 10.961, 9.042 ],
                    [ 10.094, 9.965 ],
                    [ 6.051, 8.553 ],
                    [ 1.997, 7.137 ],
                    [ -4.477, 12.867 ],
                    [ -5.618, 12.345 ],
                    [ -5.305, 3.798 ],
                    [ -12.719, -0.465 ],
                    [ -12.557, -1.709 ],
                    [ -4.267, -4.164 ],
                    [ -2.375, -12.528 ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [ 0.905205640606, 0.78973161286, 0.30304218367, 1 ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [ 39.229, 68.894 ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [ 0, 0 ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [ 100, 100 ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 7,
      "op": 91,
      "st": 7,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 27,
      "ty": 4,
      "nm": "s10",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 20.999,
              "s": [ 100 ]
            },
            {
              "i": {
                "x": [ 0.833 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.167 ],
                "y": [ 0 ]
              },
              "t": 37,
              "s": [ 0 ]
            },
            {
              "t": 120,
              "s": [ 0 ]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 7,
              "s": [ 0 ]
            },
            {
              "t": 37,
              "s": [ 50 ]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.337,
                "y": 1
              },
              "o": {
                "x": 0.191,
                "y": 0
              },
              "t": 13,
              "s": [ 53.208, 49.381, 0 ],
              "to": [ -5.958, 2.625, 0 ],
              "ti": [ 0, 0, 0 ]
            },
            {
              "t": 34,
              "s": [ 17.458, 65.131, 0 ]
            }
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [ 39.208, 68.881, 0 ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 7,
              "s": [ 0, 0, 100 ]
            },
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 20.999,
              "s": [ 24, 24, 100 ]
            },
            {
              "t": 34,
              "s": [ 27, 27, 100 ]
            }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [ -0.337, -0.493 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.372, -0.476 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.567, 0.197 ],
                    [ 0.898, 0.313 ],
                    [ 1.801, 0.629 ],
                    [ 0, 0 ],
                    [ -0.022, 0.599 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.581, 0.172 ],
                    [ 0, 0 ],
                    [ 0, 0 ]
                  ],
                  "o": [
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.601, -0.064 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.239, 0.547 ],
                    [ -1.797, -0.628 ],
                    [ -0.901, -0.314 ],
                    [ 0, 0 ],
                    [ -0.454, 0.401 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.519, -0.298 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.133, -0.585 ]
                  ],
                  "v": [
                    [ -1.133, -12.775 ],
                    [ 3.677, -5.746 ],
                    [ 12.26, -6.652 ],
                    [ 12.866, -5.561 ],
                    [ 7.549, 1.238 ],
                    [ 10.961, 9.042 ],
                    [ 10.094, 9.965 ],
                    [ 6.051, 8.553 ],
                    [ 1.997, 7.137 ],
                    [ -4.477, 12.867 ],
                    [ -5.618, 12.345 ],
                    [ -5.305, 3.798 ],
                    [ -12.719, -0.465 ],
                    [ -12.557, -1.709 ],
                    [ -4.267, -4.164 ],
                    [ -2.375, -12.528 ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [ 0.905205640606, 0.78973161286, 0.30304218367, 1 ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [ 39.229, 68.894 ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [ 0, 0 ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [ 100, 100 ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 7,
      "op": 91,
      "st": 7,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 28,
      "ty": 4,
      "nm": "s09",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 20.999,
              "s": [ 100 ]
            },
            {
              "i": {
                "x": [ 0.833 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.167 ],
                "y": [ 0 ]
              },
              "t": 37,
              "s": [ 0 ]
            },
            {
              "t": 120,
              "s": [ 0 ]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 7,
              "s": [ 0 ]
            },
            {
              "t": 37,
              "s": [ 50 ]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.337,
                "y": 1
              },
              "o": {
                "x": 0.191,
                "y": 0
              },
              "t": 14,
              "s": [ 53.208, 49.381, 0 ],
              "to": [ -6.083, 0.042, 0 ],
              "ti": [ 0, 0, 0 ]
            },
            {
              "t": 36,
              "s": [ 16.708, 49.631, 0 ]
            }
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [ 39.208, 68.881, 0 ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 7,
              "s": [ 0, 0, 100 ]
            },
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 20.999,
              "s": [ 24, 24, 100 ]
            },
            {
              "t": 34,
              "s": [ 27, 27, 100 ]
            }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [ -0.337, -0.493 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.372, -0.476 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.567, 0.197 ],
                    [ 0.898, 0.313 ],
                    [ 1.801, 0.629 ],
                    [ 0, 0 ],
                    [ -0.022, 0.599 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.581, 0.172 ],
                    [ 0, 0 ],
                    [ 0, 0 ]
                  ],
                  "o": [
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.601, -0.064 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.239, 0.547 ],
                    [ -1.797, -0.628 ],
                    [ -0.901, -0.314 ],
                    [ 0, 0 ],
                    [ -0.454, 0.401 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.519, -0.298 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.133, -0.585 ]
                  ],
                  "v": [
                    [ -1.133, -12.775 ],
                    [ 3.677, -5.746 ],
                    [ 12.26, -6.652 ],
                    [ 12.866, -5.561 ],
                    [ 7.549, 1.238 ],
                    [ 10.961, 9.042 ],
                    [ 10.094, 9.965 ],
                    [ 6.051, 8.553 ],
                    [ 1.997, 7.137 ],
                    [ -4.477, 12.867 ],
                    [ -5.618, 12.345 ],
                    [ -5.305, 3.798 ],
                    [ -12.719, -0.465 ],
                    [ -12.557, -1.709 ],
                    [ -4.267, -4.164 ],
                    [ -2.375, -12.528 ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [ 0.905205640606, 0.78973161286, 0.30304218367, 1 ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [ 39.229, 68.894 ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [ 0, 0 ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [ 100, 100 ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 7,
      "op": 91,
      "st": 7,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 29,
      "ty": 4,
      "nm": "s08",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 20.999,
              "s": [ 100 ]
            },
            {
              "i": {
                "x": [ 0.833 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.167 ],
                "y": [ 0 ]
              },
              "t": 37,
              "s": [ 0 ]
            },
            {
              "t": 120,
              "s": [ 0 ]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 7,
              "s": [ 0 ]
            },
            {
              "t": 37,
              "s": [ 50 ]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.337,
                "y": 1
              },
              "o": {
                "x": 0.191,
                "y": 0
              },
              "t": 17,
              "s": [ 53.208, 49.381, 0 ],
              "to": [ -6.125, -2.667, 0 ],
              "ti": [ 0, 0, 0 ]
            },
            {
              "t": 35,
              "s": [ 16.458, 33.381, 0 ]
            }
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [ 39.208, 68.881, 0 ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 7,
              "s": [ 0, 0, 100 ]
            },
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 20.999,
              "s": [ 24, 24, 100 ]
            },
            {
              "t": 34,
              "s": [ 27, 27, 100 ]
            }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [ -0.337, -0.493 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.372, -0.476 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.567, 0.197 ],
                    [ 0.898, 0.313 ],
                    [ 1.801, 0.629 ],
                    [ 0, 0 ],
                    [ -0.022, 0.599 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.581, 0.172 ],
                    [ 0, 0 ],
                    [ 0, 0 ]
                  ],
                  "o": [
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.601, -0.064 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.239, 0.547 ],
                    [ -1.797, -0.628 ],
                    [ -0.901, -0.314 ],
                    [ 0, 0 ],
                    [ -0.454, 0.401 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.519, -0.298 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.133, -0.585 ]
                  ],
                  "v": [
                    [ -1.133, -12.775 ],
                    [ 3.677, -5.746 ],
                    [ 12.26, -6.652 ],
                    [ 12.866, -5.561 ],
                    [ 7.549, 1.238 ],
                    [ 10.961, 9.042 ],
                    [ 10.094, 9.965 ],
                    [ 6.051, 8.553 ],
                    [ 1.997, 7.137 ],
                    [ -4.477, 12.867 ],
                    [ -5.618, 12.345 ],
                    [ -5.305, 3.798 ],
                    [ -12.719, -0.465 ],
                    [ -12.557, -1.709 ],
                    [ -4.267, -4.164 ],
                    [ -2.375, -12.528 ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [ 0.905205640606, 0.78973161286, 0.30304218367, 1 ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [ 39.229, 68.894 ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [ 0, 0 ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [ 100, 100 ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 7,
      "op": 91,
      "st": 7,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 30,
      "ty": 4,
      "nm": "s07",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 20.999,
              "s": [ 100 ]
            },
            {
              "i": {
                "x": [ 0.833 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.167 ],
                "y": [ 0 ]
              },
              "t": 37,
              "s": [ 0 ]
            },
            {
              "t": 120,
              "s": [ 0 ]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 7,
              "s": [ 0 ]
            },
            {
              "t": 37,
              "s": [ 50 ]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.337,
                "y": 1
              },
              "o": {
                "x": 0.191,
                "y": 0
              },
              "t": 13,
              "s": [ 53.208, 49.381, 0 ],
              "to": [ -4.125, -3.833, 0 ],
              "ti": [ 0, 0, 0 ]
            },
            {
              "t": 33,
              "s": [ 28.458, 26.381, 0 ]
            }
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [ 39.208, 68.881, 0 ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 7,
              "s": [ 0, 0, 100 ]
            },
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 20.999,
              "s": [ 24, 24, 100 ]
            },
            {
              "t": 34,
              "s": [ 27, 27, 100 ]
            }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [ -0.337, -0.493 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.372, -0.476 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.567, 0.197 ],
                    [ 0.898, 0.313 ],
                    [ 1.801, 0.629 ],
                    [ 0, 0 ],
                    [ -0.022, 0.599 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.581, 0.172 ],
                    [ 0, 0 ],
                    [ 0, 0 ]
                  ],
                  "o": [
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.601, -0.064 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.239, 0.547 ],
                    [ -1.797, -0.628 ],
                    [ -0.901, -0.314 ],
                    [ 0, 0 ],
                    [ -0.454, 0.401 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.519, -0.298 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.133, -0.585 ]
                  ],
                  "v": [
                    [ -1.133, -12.775 ],
                    [ 3.677, -5.746 ],
                    [ 12.26, -6.652 ],
                    [ 12.866, -5.561 ],
                    [ 7.549, 1.238 ],
                    [ 10.961, 9.042 ],
                    [ 10.094, 9.965 ],
                    [ 6.051, 8.553 ],
                    [ 1.997, 7.137 ],
                    [ -4.477, 12.867 ],
                    [ -5.618, 12.345 ],
                    [ -5.305, 3.798 ],
                    [ -12.719, -0.465 ],
                    [ -12.557, -1.709 ],
                    [ -4.267, -4.164 ],
                    [ -2.375, -12.528 ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [ 0.905205640606, 0.78973161286, 0.30304218367, 1 ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [ 39.229, 68.894 ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [ 0, 0 ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [ 100, 100 ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 7,
      "op": 91,
      "st": 7,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 31,
      "ty": 4,
      "nm": "s06",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 20.999,
              "s": [ 100 ]
            },
            {
              "i": {
                "x": [ 0.833 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.167 ],
                "y": [ 0 ]
              },
              "t": 37,
              "s": [ 0 ]
            },
            {
              "t": 120,
              "s": [ 0 ]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 7,
              "s": [ 0 ]
            },
            {
              "t": 37,
              "s": [ 50 ]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.337,
                "y": 1
              },
              "o": {
                "x": 0.191,
                "y": 0
              },
              "t": 15,
              "s": [ 53.208, 49.381, 0 ],
              "to": [ -2.5, -5.292, 0 ],
              "ti": [ 0, 0, 0 ]
            },
            {
              "t": 37,
              "s": [ 38.208, 17.631, 0 ]
            }
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [ 39.208, 68.881, 0 ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 7,
              "s": [ 0, 0, 100 ]
            },
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 20.999,
              "s": [ 24, 24, 100 ]
            },
            {
              "t": 34,
              "s": [ 27, 27, 100 ]
            }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [ -0.337, -0.493 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.372, -0.476 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.567, 0.197 ],
                    [ 0.898, 0.313 ],
                    [ 1.801, 0.629 ],
                    [ 0, 0 ],
                    [ -0.022, 0.599 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.581, 0.172 ],
                    [ 0, 0 ],
                    [ 0, 0 ]
                  ],
                  "o": [
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.601, -0.064 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.239, 0.547 ],
                    [ -1.797, -0.628 ],
                    [ -0.901, -0.314 ],
                    [ 0, 0 ],
                    [ -0.454, 0.401 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.519, -0.298 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.133, -0.585 ]
                  ],
                  "v": [
                    [ -1.133, -12.775 ],
                    [ 3.677, -5.746 ],
                    [ 12.26, -6.652 ],
                    [ 12.866, -5.561 ],
                    [ 7.549, 1.238 ],
                    [ 10.961, 9.042 ],
                    [ 10.094, 9.965 ],
                    [ 6.051, 8.553 ],
                    [ 1.997, 7.137 ],
                    [ -4.477, 12.867 ],
                    [ -5.618, 12.345 ],
                    [ -5.305, 3.798 ],
                    [ -12.719, -0.465 ],
                    [ -12.557, -1.709 ],
                    [ -4.267, -4.164 ],
                    [ -2.375, -12.528 ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [ 0.905205640606, 0.78973161286, 0.30304218367, 1 ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [ 39.229, 68.894 ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [ 0, 0 ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [ 100, 100 ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 7,
      "op": 91,
      "st": 7,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 32,
      "ty": 4,
      "nm": "s05",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 20.999,
              "s": [ 100 ]
            },
            {
              "i": {
                "x": [ 0.833 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.167 ],
                "y": [ 0 ]
              },
              "t": 37,
              "s": [ 0 ]
            },
            {
              "t": 120,
              "s": [ 0 ]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 7,
              "s": [ 0 ]
            },
            {
              "t": 37,
              "s": [ 50 ]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.337,
                "y": 1
              },
              "o": {
                "x": 0.191,
                "y": 0
              },
              "t": 14,
              "s": [ 53.208, 49.381, 0 ],
              "to": [ -0.167, -6.25, 0 ],
              "ti": [ 0, 0, 0 ]
            },
            {
              "t": 35,
              "s": [ 52.208, 11.881, 0 ]
            }
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [ 39.208, 68.881, 0 ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 7,
              "s": [ 0, 0, 100 ]
            },
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 20.999,
              "s": [ 24, 24, 100 ]
            },
            {
              "t": 34,
              "s": [ 27, 27, 100 ]
            }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [ -0.337, -0.493 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.372, -0.476 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.567, 0.197 ],
                    [ 0.898, 0.313 ],
                    [ 1.801, 0.629 ],
                    [ 0, 0 ],
                    [ -0.022, 0.599 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.581, 0.172 ],
                    [ 0, 0 ],
                    [ 0, 0 ]
                  ],
                  "o": [
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.601, -0.064 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.239, 0.547 ],
                    [ -1.797, -0.628 ],
                    [ -0.901, -0.314 ],
                    [ 0, 0 ],
                    [ -0.454, 0.401 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.519, -0.298 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.133, -0.585 ]
                  ],
                  "v": [
                    [ -1.133, -12.775 ],
                    [ 3.677, -5.746 ],
                    [ 12.26, -6.652 ],
                    [ 12.866, -5.561 ],
                    [ 7.549, 1.238 ],
                    [ 10.961, 9.042 ],
                    [ 10.094, 9.965 ],
                    [ 6.051, 8.553 ],
                    [ 1.997, 7.137 ],
                    [ -4.477, 12.867 ],
                    [ -5.618, 12.345 ],
                    [ -5.305, 3.798 ],
                    [ -12.719, -0.465 ],
                    [ -12.557, -1.709 ],
                    [ -4.267, -4.164 ],
                    [ -2.375, -12.528 ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [ 0.905205640606, 0.78973161286, 0.30304218367, 1 ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [ 39.229, 68.894 ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [ 0, 0 ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [ 100, 100 ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 7,
      "op": 91,
      "st": 7,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 33,
      "ty": 4,
      "nm": "s04",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 20.999,
              "s": [ 100 ]
            },
            {
              "i": {
                "x": [ 0.833 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.167 ],
                "y": [ 0 ]
              },
              "t": 37,
              "s": [ 0 ]
            },
            {
              "t": 120,
              "s": [ 0 ]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 7,
              "s": [ 0 ]
            },
            {
              "t": 37,
              "s": [ 50 ]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.337,
                "y": 1
              },
              "o": {
                "x": 0.191,
                "y": 0
              },
              "t": 13,
              "s": [ 53.208, 49.381, 0 ],
              "to": [ 2.542, -6.083, 0 ],
              "ti": [ 0, 0, 0 ]
            },
            {
              "t": 36,
              "s": [ 68.458, 12.881, 0 ]
            }
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [ 39.208, 68.881, 0 ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 7,
              "s": [ 0, 0, 100 ]
            },
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 20.999,
              "s": [ 24, 24, 100 ]
            },
            {
              "t": 34,
              "s": [ 27, 27, 100 ]
            }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [ -0.337, -0.493 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.372, -0.476 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.567, 0.197 ],
                    [ 0.898, 0.313 ],
                    [ 1.801, 0.629 ],
                    [ 0, 0 ],
                    [ -0.022, 0.599 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.581, 0.172 ],
                    [ 0, 0 ],
                    [ 0, 0 ]
                  ],
                  "o": [
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.601, -0.064 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.239, 0.547 ],
                    [ -1.797, -0.628 ],
                    [ -0.901, -0.314 ],
                    [ 0, 0 ],
                    [ -0.454, 0.401 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.519, -0.298 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.133, -0.585 ]
                  ],
                  "v": [
                    [ -1.133, -12.775 ],
                    [ 3.677, -5.746 ],
                    [ 12.26, -6.652 ],
                    [ 12.866, -5.561 ],
                    [ 7.549, 1.238 ],
                    [ 10.961, 9.042 ],
                    [ 10.094, 9.965 ],
                    [ 6.051, 8.553 ],
                    [ 1.997, 7.137 ],
                    [ -4.477, 12.867 ],
                    [ -5.618, 12.345 ],
                    [ -5.305, 3.798 ],
                    [ -12.719, -0.465 ],
                    [ -12.557, -1.709 ],
                    [ -4.267, -4.164 ],
                    [ -2.375, -12.528 ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [ 0.905205640606, 0.78973161286, 0.30304218367, 1 ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [ 39.229, 68.894 ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [ 0, 0 ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [ 100, 100 ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 7,
      "op": 91,
      "st": 7,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 34,
      "ty": 4,
      "nm": "s03",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 20.999,
              "s": [ 100 ]
            },
            {
              "i": {
                "x": [ 0.833 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.167 ],
                "y": [ 0 ]
              },
              "t": 37,
              "s": [ 0 ]
            },
            {
              "t": 120,
              "s": [ 0 ]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 7,
              "s": [ 0 ]
            },
            {
              "t": 37,
              "s": [ 50 ]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.337,
                "y": 1
              },
              "o": {
                "x": 0.191,
                "y": 0
              },
              "t": 15,
              "s": [ 53.208, 49.381, 0 ],
              "to": [ 5.208, -5, 0 ],
              "ti": [ 0, 0, 0 ]
            },
            {
              "t": 34,
              "s": [ 84.458, 19.381, 0 ]
            }
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [ 39.208, 68.881, 0 ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 7,
              "s": [ 0, 0, 100 ]
            },
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 20.999,
              "s": [ 24, 24, 100 ]
            },
            {
              "t": 34,
              "s": [ 27, 27, 100 ]
            }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [ -0.337, -0.493 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.372, -0.476 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.567, 0.197 ],
                    [ 0.898, 0.313 ],
                    [ 1.801, 0.629 ],
                    [ 0, 0 ],
                    [ -0.022, 0.599 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.581, 0.172 ],
                    [ 0, 0 ],
                    [ 0, 0 ]
                  ],
                  "o": [
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.601, -0.064 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.239, 0.547 ],
                    [ -1.797, -0.628 ],
                    [ -0.901, -0.314 ],
                    [ 0, 0 ],
                    [ -0.454, 0.401 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.519, -0.298 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.133, -0.585 ]
                  ],
                  "v": [
                    [ -1.133, -12.775 ],
                    [ 3.677, -5.746 ],
                    [ 12.26, -6.652 ],
                    [ 12.866, -5.561 ],
                    [ 7.549, 1.238 ],
                    [ 10.961, 9.042 ],
                    [ 10.094, 9.965 ],
                    [ 6.051, 8.553 ],
                    [ 1.997, 7.137 ],
                    [ -4.477, 12.867 ],
                    [ -5.618, 12.345 ],
                    [ -5.305, 3.798 ],
                    [ -12.719, -0.465 ],
                    [ -12.557, -1.709 ],
                    [ -4.267, -4.164 ],
                    [ -2.375, -12.528 ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [ 0.905205640606, 0.78973161286, 0.30304218367, 1 ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [ 39.229, 68.894 ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [ 0, 0 ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [ 100, 100 ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 7,
      "op": 91,
      "st": 7,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 35,
      "ty": 4,
      "nm": "s02",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 20.999,
              "s": [ 100 ]
            },
            {
              "i": {
                "x": [ 0.833 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.167 ],
                "y": [ 0 ]
              },
              "t": 37,
              "s": [ 0 ]
            },
            {
              "t": 120,
              "s": [ 0 ]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 7,
              "s": [ 0 ]
            },
            {
              "t": 37,
              "s": [ 50 ]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.337,
                "y": 1
              },
              "o": {
                "x": 0.191,
                "y": 0
              },
              "t": 7,
              "s": [ 53.208, 49.381, 0 ],
              "to": [ 5.333, -2.542, 0 ],
              "ti": [ 0, 0, 0 ]
            },
            {
              "t": 36,
              "s": [ 85.208, 34.131, 0 ]
            }
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [ 39.208, 68.881, 0 ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 7,
              "s": [ 0, 0, 100 ]
            },
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 20.999,
              "s": [ 24, 24, 100 ]
            },
            {
              "t": 34,
              "s": [ 27, 27, 100 ]
            }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [ -0.337, -0.493 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.372, -0.476 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.567, 0.197 ],
                    [ 0.898, 0.313 ],
                    [ 1.801, 0.629 ],
                    [ 0, 0 ],
                    [ -0.022, 0.599 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.581, 0.172 ],
                    [ 0, 0 ],
                    [ 0, 0 ]
                  ],
                  "o": [
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.601, -0.064 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.239, 0.547 ],
                    [ -1.797, -0.628 ],
                    [ -0.901, -0.314 ],
                    [ 0, 0 ],
                    [ -0.454, 0.401 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.519, -0.298 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.133, -0.585 ]
                  ],
                  "v": [
                    [ -1.133, -12.775 ],
                    [ 3.677, -5.746 ],
                    [ 12.26, -6.652 ],
                    [ 12.866, -5.561 ],
                    [ 7.549, 1.238 ],
                    [ 10.961, 9.042 ],
                    [ 10.094, 9.965 ],
                    [ 6.051, 8.553 ],
                    [ 1.997, 7.137 ],
                    [ -4.477, 12.867 ],
                    [ -5.618, 12.345 ],
                    [ -5.305, 3.798 ],
                    [ -12.719, -0.465 ],
                    [ -12.557, -1.709 ],
                    [ -4.267, -4.164 ],
                    [ -2.375, -12.528 ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [ 0.905205640606, 0.78973161286, 0.30304218367, 1 ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [ 39.229, 68.894 ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [ 0, 0 ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [ 100, 100 ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 7,
      "op": 91,
      "st": 7,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 36,
      "ty": 4,
      "nm": "s01",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 20.999,
              "s": [ 100 ]
            },
            {
              "i": {
                "x": [ 0.833 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.167 ],
                "y": [ 0 ]
              },
              "t": 37,
              "s": [ 0 ]
            },
            {
              "t": 120,
              "s": [ 0 ]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667 ],
                "y": [ 1 ]
              },
              "o": {
                "x": [ 0.333 ],
                "y": [ 0 ]
              },
              "t": 7,
              "s": [ 0 ]
            },
            {
              "t": 37,
              "s": [ 50 ]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.337,
                "y": 1
              },
              "o": {
                "x": 0.191,
                "y": 0
              },
              "t": 7,
              "s": [ 53.208, 49.381, 0 ],
              "to": [ 5.667, -0.083, 0 ],
              "ti": [ -5.667, 0.083, 0 ]
            },
            {
              "t": 37,
              "s": [ 87.208, 48.881, 0 ]
            }
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [ 39.208, 68.881, 0 ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 7,
              "s": [ 0, 0, 100 ]
            },
            {
              "i": {
                "x": [ 0.667, 0.667, 0.667 ],
                "y": [ 1, 1, 1 ]
              },
              "o": {
                "x": [ 0.333, 0.333, 0.333 ],
                "y": [ 0, 0, 0 ]
              },
              "t": 20.999,
              "s": [ 24, 24, 100 ]
            },
            {
              "t": 34,
              "s": [ 27, 27, 100 ]
            }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [ -0.337, -0.493 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.372, -0.476 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.567, 0.197 ],
                    [ 0.898, 0.313 ],
                    [ 1.801, 0.629 ],
                    [ 0, 0 ],
                    [ -0.022, 0.599 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.581, 0.172 ],
                    [ 0, 0 ],
                    [ 0, 0 ]
                  ],
                  "o": [
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.601, -0.064 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.239, 0.547 ],
                    [ -1.797, -0.628 ],
                    [ -0.901, -0.314 ],
                    [ 0, 0 ],
                    [ -0.454, 0.401 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ -0.519, -0.298 ],
                    [ 0, 0 ],
                    [ 0, 0 ],
                    [ 0.133, -0.585 ]
                  ],
                  "v": [
                    [ -1.133, -12.775 ],
                    [ 3.677, -5.746 ],
                    [ 12.26, -6.652 ],
                    [ 12.866, -5.561 ],
                    [ 7.549, 1.238 ],
                    [ 10.961, 9.042 ],
                    [ 10.094, 9.965 ],
                    [ 6.051, 8.553 ],
                    [ 1.997, 7.137 ],
                    [ -4.477, 12.867 ],
                    [ -5.618, 12.345 ],
                    [ -5.305, 3.798 ],
                    [ -12.719, -0.465 ],
                    [ -12.557, -1.709 ],
                    [ -4.267, -4.164 ],
                    [ -2.375, -12.528 ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [ 0.905205640606, 0.78973161286, 0.30304218367, 1 ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [ 39.229, 68.894 ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [ 0, 0 ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [ 100, 100 ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 7,
      "op": 91,
      "st": 7,
      "bm": 0
    }
  ],
  "markers": []
}